<template>
	<div class="content">
		<div class="content_head">
			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="pageIndex=1;getData()" >
				<option v-for="(i,index) in $store.state.area" :value="i.areaID"  >{{i.areaName}}</option>
			</select>
			<input type="text" @keypress.enter="pageIndex=1;getData()" placeholder="书籍条码|书籍编码|书籍名称|作者名称" class="search"
				v-model="search" />
			<button type="button" class="button " @click="pageIndex=1;getData()" title="点击进行查找">查找</button>

		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>书籍信息</th>
						<th>图书信息</th>
						<th>编辑</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in books">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							<div class="bookBaseInfor">
								<div>
									书籍名称:
								</div>
								<div>
									{{i.BooksName}}
								</div>
								<div>
									书籍作者:
								</div>
								<div>
									{{i.WriterName + ' '+ WriterBooksReferences}}
								</div>

								<div>
									书籍分类:
								</div>
								<div>
									{{i.Classification1}}
								</div>
								<div>
									书籍状态:
								</div>
								<div>
									{{i.BooksSate==0?'正常':'已下架'}}
								</div>

							</div>

						</td>
						<td>
							<div class="bookInfor">
								<div>
									借出次数:
								</div>
								<div>
									{{i.BorrowCount}}
								</div>
								<div v-if="$store.state.user.UserType==0">
									图书总量:
								</div>
								<div v-if="$store.state.user.UserType==0">
									<p>{{i.booksCount+'本'}}</p>
								</div>
								<div>
									地区数量:
								</div>
								<div>
									
									<p>{{i.areaAvailableCount+'/'+i.areaCount+'本'}}</p>
									<p v-for="k in i.booksPlace" v-if="$store.state.user.UserType==0 || k.Key==$store.state.user.ShopName">
										{{k.Key +':'+k.Qty+'本'}}
									</p>
								</div>
								<div>
									图书编号:
								</div>
								<div>
									<span style="display: inline-block;margin-left: .2rem;" class="buttonSamll"
										v-for="j in i.books" v-if="$store.state.user.UserType==0 || j.OriginalShopID==$store.state.user.ShopID || j.ShopID==$store.state.user.ShopID">
										{{j.BooksNumCode}}
									</span>
								</div>
							</div>

						</td>

						<td>
							<button type="button" class="button" @click="$router.push('/booksDetail/'+i.BooksID+'/'+areaID)"
								title="点击进行图书管理">
								图书管理
							</button><br />
							<button type="button" class="button" @click='updateBooks(i)' title="点击查看书籍详情">
								书籍详情
							</button><br />


						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
		</div>
		<div class="booksMangement" v-show="Edit!=''" ref='myBooks'>
			<div>
				<div>
					<span class="red">*</span>书籍名称:
				</div>
				<div>
					<input type="text" v-model="BooksName" placeholder="请输入书籍名称" />
					<span class="err">{{BooksName.length>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>书籍作者:
				</div>
				<div>


					<input type="text" v-model="WriterName" placeholder="请输入作者" :readonly="WriterID!=1" />

					<span class="err">{{WriterName.length>0?' ':'×'}}</span>

				</div>



				<div>
					<span class="red">&nbsp;</span>关系:
				</div>

				<div>

					<label v-for="i in  WriterBooksReferencesType" v-if='i==WriterBooksReferences'>
						<input type="radio" :checked="i==WriterBooksReferences" name="WriterBooksReferences" :value="i"
							@change="WriterBooksReferences=i" />
						{{i}}
					</label>

				</div>

				<div>
					<span class="red">*</span>推荐理由:
				</div>
				<div>
					<label>

						<input type="text" v-model="RecommendReason" placeholder="上架原因" />
						<span class="err">{{RecommendReason.length>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					<span class="red">*</span>选择归属:
				</div>
				<div>
					<label>

						<select v-model="ClassificationID">
							<option v-for="(i,index) in $store.state.Classification" :value="i.ClassificationID">
								{{i.Classification1}}
							</option>
						</select>
						<span class="err">{{ClassificationID>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>书籍分类:
				</div>
				<div>
					<label>
						<span v-for="(i,index) in CategoryMenuName">
							<button type="button" class="buttonSamll" >{{i}}</button>
						</span>

					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>其他分类:
				</div>
				<div>
					<label>
						<span v-for="(i,index) in CategoryAttribute">
							<button type="button" class="buttonSamll">{{i}}</button>
						</span>

					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>自定义分类:
				</div>
				<div>
					<label>
						<span v-for="(i,index) in customCategory">
							<button type="button" class="buttonSamll">{{i}}</button>
						</span>

					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>书籍标签:
				</div>
				<div>
					<label v-for="(i,index) in Tag">

						<button class="buttonSamll" title="点击移除">{{i}} </button>&nbsp;
					</label>
				</div>
				<div>
					<span class="red"></span>归属系列:
				</div>
				<div>
					<label>
						<input type="text" v-model="BelongTo" />
					</label>
				</div>
				<div>
					<span class="red">&nbsp;</span>书籍简介:
				</div>
				<div>
					<label>

						<textarea v-model="BookBriefIntroduction" placeholder="请输入书籍简介" class="booksTextArea">


						</textarea>
						<span class="err">{{BookBriefIntroduction.length>0?' ':'×'}}</span>
					</label>
				</div>

				<div>
					编辑寄语:
				</div>
				<div>
					<label>

						<textarea v-model="BookRecommend" placeholder="请输入编辑寄语" class="booksTextArea">


						</textarea>

					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>书籍状态:
				</div>
				<div>
					<label>

						<select v-model="BooksSate">
							<option value="0">正常</option>
							<option value="1">下架</option>
						</select>

					</label>
				</div>

				<div>
					<span class="red">&nbsp;</span>书籍备注:
				</div>
				<div>
					<label>

						<textarea v-model="BooksDesc" placeholder="书籍变动备注" class="booksTextArea">


						</textarea>

					</label>
				</div>

				<div>

				</div>
				<div style="text-align: center;padding-top: 1rem;">
					<button class="button" @click="cancel">确定</button>
				</div>

			</div>


		</div>



	</div>
</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
	.bookInfor {
		grid-template-columns: 5rem 1fr ;
	}

	.bookBaseInfor {
		grid-template-columns: 5rem 15rem;
	}

	.bookInfor,
	.bookBaseInfor {
		display: grid;

		grid-gap: .2rem;
		line-height: 1.5rem;
		justify-content: center;
	}

	.bookInfor div:nth-child(even),
	.bookBaseInfor div:nth-child(even) {
		text-align: left;
		white-space: normal;
		word-break: break-all;
		overflow: hidden;
	}
</style>
